<script lang="ts">
    import { getDBEntries, getDBEntry, putDBEntry } from "../../api"
    import { actionApproval, login, newNotification, taskEditors } from "../store"
    import { checkIfStepIsBlockedByOtherUser, checkIfStepIsCompleted } from "./helper"
    import TaskStepsPage from "./TaskStepsPage.svelte"

    export let step: TaskStep,
        task: TaskOilSpillRemoval | TaskTowing,
        stepNr: number,
        checkAndUpdateTaskManipulationState: (i: number) => Promise<void>

    let rerenderStep = false
    async function overtakStep() {
        checkAndUpdateTaskManipulationState(stepNr - 1).then(() => {
            let editor = Object.values($taskEditors).find((editor) => editor.stepNr === stepNr)
            const idOfUser = Object.keys($taskEditors).find((key) => $taskEditors[key].id === editor.id)
            if (idOfUser == $login.user.id) {
                rerenderStep = !rerenderStep
                return
            }
            putDBEntry("taskManipulationState", {
                ...editor,
                kickedOut: true,
                taskId: task.id,
                orderId: task.orderId,
                manipulator: {
                    id: idOfUser,
                    name: "",
                },
                sort: null,
            }).then(() => {
                // check periodically if the user is still editing the task
                const interval = setInterval(() => {
                    getDBEntries("taskManipulationState", {
                        taskId: task.id,
                        _id: editor.id,
                    }).then((taskManipulationState) => {
                        if (!taskManipulationState.length) {
                            clearInterval(interval)
                            checkAndUpdateTaskManipulationState(stepNr - 1).then(() => {
                                newNotification({
                                    html: "Bearbeitung übernommen",
                                    class: "success",
                                })
                                rerenderStep = !rerenderStep
                            })
                        } else
                            newNotification({
                                html: "Warte auf Bearbeitung",
                                class: "warning",
                                timeout: 1000,
                            })
                    })
                }, 1000)
            })
        })
    }
</script>

{#key rerenderStep}
    <div class="wrapper">
        {#if checkIfStepIsCompleted(task, stepNr)}
            <div class="blocker completed">
                {#if $login.user.roles.includes("admin")}
                    <button
                        on:click="{() => {
                            if (!$login.user.roles.includes('admin')) {
                                newNotification({
                                    html: 'Nur Administratoren können Schritte wieder öffnen.',
                                    class: 'error',
                                })
                                return
                            }
                            $actionApproval = {
                                modalTitle: 'Schritt öffnen',
                                modalText: 'Sind Sie sicher, dass Sie den Schritt wieder öffnen möchten?',
                                callback: () =>
                                    getDBEntry('task', { _id: task.id }).then((innerTask) => {
                                        //@ts-ignore
                                        putDBEntry('task', {
                                            id: innerTask.id,
                                            status: 'inProgress',
                                            completedSteps: [...(innerTask.completedSteps || [])].filter(
                                                (el) => el.stepNr !== stepNr
                                            ),
                                        })
                                            .then(() => {
                                                location.reload()
                                            })
                                            .catch(() => {
                                                newNotification({
                                                    html: 'Fehler beim wieder öffnen des Schrittes',
                                                    class: 'error',
                                                })
                                            })
                                    }),
                            }
                        }}"
                    >
                        <img
                            src="../../../assets/icons/solar_check-read-broken-white.svg"
                            alt="edit"
                        />
                        <span>Schritt wieder öffnen</span>
                    </button>
                {/if}
            </div>
        {:else if checkIfStepIsBlockedByOtherUser(stepNr, $taskEditors)}
            <div class="blocker blocked">
                {#if $login.user.roles.includes("admin")}
                    <button
                        on:click="{async () => {
                            if (!$login.user.roles.includes('admin')) {
                                newNotification({
                                    html: 'Nur Administratoren können Schritte übernehmen.',
                                    class: 'error',
                                })
                                return
                            }
                            $actionApproval = {
                                modalTitle: 'Schritt übernehmen',
                                modalText:
                                    'Möchten Sie den Schritt übernehmen? Der aktuelle Bearbeiter wird umgehend rausgeschmissen. Er hat keine Chance zu speichern.',
                                callback: overtakStep,
                            }
                        }}"
                        ><img
                            src="../../../assets/icons/solar_lock-unlocked-bold-white.svg"
                            alt="edit"
                        />
                        <span>Bearbeitung übernehmen</span>
                    </button>
                {/if}
            </div>
        {/if}
        <div class="grid step">
            {#each step.pages as page}
                <div class="{page.size ? page.size : 'col-' + 12 / step.pages.length} step-page">
                    <TaskStepsPage
                        page="{page}"
                        fullPath="{step.pathInDb}"
                        bind:value="{task[step.pathInDb]}"
                    />
                </div>
            {/each}
        </div>
    </div>
{/key}

<style lang="less">
    @import "../../../assets/variables.less";
    .wrapper {
        width: 100%;
        position: relative;
        height: 100%;
        .grid {
            padding: 0.6rem 0rem;
            border-right: 1px solid var(--grey-200);
            &:first-child {
                padding-left: 0px;
            }
            &:last-child {
                padding-right: 0px;
                border-right: 0px;
            }
        }
        .blocker {
            position: absolute;
            z-index: 999;
            top: 0px;
            right: 0px;
            left: 0px;
            bottom: 0px;
            background-color: rgba(255, 255, 255, 0.7);
            button {
                position: absolute;
                z-index: 1000;
                top: 0px;
                right: 0px;
                display: flex;
                padding: 0.6rem;
                align-items: center;
                gap: 0.5rem;
                color: white;
                border-radius: 0px 0px 0px 12px;
                span {
                    font-weight: 700;
                    font-size: 0.8rem;
                    line-height: 0.5rem;
                }
                img {
                    height: 0.5rem;
                }
            }
            &.blocked {
                border: 2px solid var(--red-100);
                button {
                    background-color: var(--red-100);
                }
            }
            &.completed {
                border: 2px solid var(--confirm-100);
                button {
                    background-color: var(--confirm-100);
                }
            }
        }

        .step {
            gap: 0px;
            .step-page {
                padding: 0rem 1.2rem !important;
                border-right: 1px dashed var(--grey-200);
                &:first-child {
                    padding-left: 0px;
                    padding-right: 1.2rem;
                }
                &:last-child {
                    padding-right: 0px;
                    padding-left: 1.2rem;
                    border-right: 0px solid black;
                }
                @media @mobile {
                    padding: 1.2rem 1.2rem !important;
                    border-right: 0px solid black;
                    border-bottom: 1px dashed var(--grey-200);
                    &:first-child {
                        padding-top: 0px;
                    }
                    &:last-child {
                        padding-bottom: 0px;
                        border-bottom: 0px solid black;
                    }
                }
            }
        }
    }
</style>
